import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

/**
 * Hook für einfachen Zugriff auf Übersetzungen
 * 
 * @example
 * const { t, language, setLanguage, availableLanguages, languageNames } = useTranslation();
 * 
 * // Einfache Übersetzung
 * t('common.save') // -> "Speichern" (DE) oder "Save" (EN)
 * 
 * // Mit Variablen
 * t('packages.daysUntilDeletion', { days: 5 }) // -> "Noch 5 Tag(e) bis Löschung"
 * 
 * // Sprache ändern
 * setLanguage('en')
 * 
 * // Alle Sprachen anzeigen
 * availableLanguages.map(lang => (
 *   <button onClick={() => setLanguage(lang)}>
 *     {languageNames[lang]}
 *   </button>
 * ))
 */
export const useTranslation = () => {
  const context = useContext(LanguageContext);
  
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  
  return context;
};

export default useTranslation;
